var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewSessionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 115.137L112.5 106.137V94.5H103.5V109.863L115.137 121.5L121.5 115.137Z",
    fill: "#1F7E78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 139.5C90.63 139.5 76.5 125.37 76.5 108C76.5 90.63 90.63 76.5 108 76.5C125.37 76.5 139.5 90.63 139.5 108C139.5 125.37 125.37 139.5 108 139.5ZM108 85.5C95.5935 85.5 85.5 95.5935 85.5 108C85.5 120.407 95.5935 130.5 108 130.5C120.407 130.5 130.5 120.407 130.5 108C130.5 95.5935 120.407 85.5 108 85.5ZM126 67.5H135V22.5C135 17.5365 130.964 13.5 126 13.5H112.5V22.5H126V67.5Z",
    fill: "#1F7E78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 67.5C45.4706 67.5 49.5 63.4706 49.5 58.5C49.5 53.5294 45.4706 49.5 40.5 49.5C35.5294 49.5 31.5 53.5294 31.5 58.5C31.5 63.4706 35.5294 67.5 40.5 67.5Z",
    fill: "#1F7E78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67.5C76.9706 67.5 81 63.4706 81 58.5C81 53.5294 76.9706 49.5 72 49.5C67.0294 49.5 63 53.5294 63 58.5C63 63.4706 67.0294 67.5 72 67.5Z",
    fill: "#1F7E78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 67.5C108.471 67.5 112.5 63.4706 112.5 58.5C112.5 53.5294 108.471 49.5 103.5 49.5C98.5294 49.5 94.5 53.5294 94.5 58.5C94.5 63.4706 98.5294 67.5 103.5 67.5Z",
    fill: "#1F7E78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 103.5H18C13.0365 103.5 9 99.4635 9 94.5V22.5C9 17.5365 13.0365 13.5 18 13.5H31.5V22.5H18V94.5H31.5V103.5Z",
    fill: "#1F7E78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewSessionSvg);
export default __webpack_public_path__ + "static/media/AddNewSessionSvg.8cdd7f4dade6deb322c15dea2ff46d83.svg";
export { ForwardRef as ReactComponent };